module.exports = __webpack_public_path__ + "static/media/wyb2.1676245a.mp4";